import type { PowerMeterFooterViewProps } from "./types"

export const PowerMeterFooterView = ({
  selectedPower,
  totalPower,
  selectedCount,
  onConfirm,
}: PowerMeterFooterViewProps) => {
  const percentage = totalPower > 0 ? (selectedPower / totalPower) * 100 : 0

  return (
    <div className="sticky bottom-0 left-0 right-0 z-20 border-t border-p400-light bg-p400/95 p-4 shadow-2xl backdrop-blur-xl sm:p-6">
      <div className="mx-auto w-full max-w-5xl">
        <div className="mb-3 flex items-end justify-between">
          <div>
            <span className="mb-1 block text-sm text-t200">Total Voting Power Selected</span>
            <div className="flex items-baseline gap-2">
              <span className="text-2xl font-bold text-t100">
                {selectedPower.toLocaleString(undefined, { maximumFractionDigits: 0 })}
              </span>
              <span className="text-sm font-medium text-t300">
                / {totalPower.toLocaleString(undefined, { maximumFractionDigits: 0 })} veSCALE
              </span>
            </div>
          </div>

          <div className="hidden text-right sm:block">
            <span className="text-3xl font-bold text-primary-400">{selectedCount}</span>
            <span className="ml-2 text-sm text-t300">NFTs</span>
          </div>
        </div>

        {/* Progress Bar */}
        <div className="mb-6 h-2 overflow-hidden rounded-full bg-p300">
          <div
            className="h-full bg-gradient-to-r from-primary-600 to-primary-400 shadow-[0_0_10px_rgba(59,130,246,0.5)] transition-all duration-500 ease-out"
            style={{ width: `${percentage || 2}%` }}
          />
        </div>

        <button
          onClick={onConfirm}
          className="hover:bg-primary-400-light w-full rounded-xl bg-primary-400 py-4 text-lg font-bold text-t100 shadow-lg shadow-primary-900/40 transition-all hover:scale-[1.01] active:scale-[0.99]"
        >
          Confirm & Apply Power
        </button>
      </div>
    </div>
  )
}
